// Doküman ekle / düzenle / yeni sürüm yükle
import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Pick } from '../settings/UserAnnouncementFormDialog';
import { ACCEPT, fileSize } from './docLibShared';

const FilePick = ({ file, setFile }) => (
  <label className="flex cursor-pointer items-center gap-3 rounded-lg border-2 border-dashed border-slate-300 bg-slate-50 px-4 py-5 text-sm hover:border-slate-400 transition-colors" data-testid="doc-file-drop">
    <input type="file" accept={ACCEPT} className="hidden" onChange={(e) => setFile(e.target.files?.[0] || null)} data-testid="doc-file-input" />
    {file ? <span className="font-medium text-slate-800 truncate">{file.name} <span className="font-normal text-slate-400">· {fileSize(file.size)}</span></span>
      : <span className="text-slate-500">Dosya seçin (PDF, Word, Excel, PowerPoint, TXT, Görsel · en fazla 20 MB)</span>}
  </label>
);

// mode: 'create' | 'edit' | 'version'
export const DocFormDialog = ({ mode, doc, categories, locations, onClose, onSave }) => {
  const [f, setF] = useState({ title: '', category_id: '', location_ids: [], is_active: true });
  const [file, setFile] = useState(null);
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    setF(doc?.id ? { title: doc.title, category_id: doc.category_id, location_ids: doc.location_ids || [], is_active: doc.is_active } : { title: '', category_id: categories[0]?.id || '', location_ids: [], is_active: true });
    setFile(null); setNote('');
  }, [mode, doc, categories]);
  const valid = mode === 'version' ? !!file : f.category_id && (mode === 'edit' ? f.title.trim() : file);
  const submit = async () => { setBusy(true); await onSave({ ...f, file, note }); setBusy(false); };
  const titles = { create: 'Yeni Doküman', edit: 'Dokümanı Düzenle', version: `Yeni Sürüm Yükle · ${doc?.title || ''}` };
  return (
    <Dialog open={!!mode} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-xl" data-testid="doc-form-dialog">
        <DialogHeader><DialogTitle>{titles[mode]}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          {mode !== 'edit' && <FilePick file={file} setFile={setFile} />}
          {mode === 'version' ? (
            <div className="space-y-1.5"><Label>Sürüm notu <span className="text-xs font-normal text-slate-400">(opsiyonel)</span></Label>
              <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Örn. 2026 revizyonu" data-testid="doc-version-note" /></div>
          ) : (
            <>
              <div className="space-y-1.5"><Label>Başlık {mode === 'create' && <span className="text-xs font-normal text-slate-400">(boş = dosya adı)</span>}</Label>
                <Input value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} data-testid="doc-title-input" /></div>
              <div className="space-y-1.5"><Label>Kategori</Label>
                <Select value={f.category_id} onValueChange={(v) => setF({ ...f, category_id: v })}>
                  <SelectTrigger data-testid="doc-category-select"><SelectValue placeholder="Kategori seçin" /></SelectTrigger>
                  <SelectContent>{categories.map(c => <SelectItem key={c.id} value={c.id} data-testid={`doc-category-opt-${c.id}`}>{c.name}</SelectItem>)}</SelectContent>
                </Select></div>
              <Pick label="Lokasyon" options={locations} value={f.location_ids} onChange={(v) => setF({ ...f, location_ids: v })} testId="doc-locations" />
            </>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="doc-form-cancel">Vazgeç</Button>
          <Button onClick={submit} disabled={!valid || busy} className="bg-slate-900 hover:bg-slate-800" data-testid="doc-form-save">{busy ? 'Kaydediliyor...' : 'Kaydet'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
